import { getLegalUnitList } from "../services/globalData";

export const getLocationNameFromLegalUnit = (id) =>{
    const legalUnit = getLegalUnitList()?.find(unit => unit?._id === id);
    return legalUnit ? legalUnit?.name : null;
}